import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "light",
  layout: "AppLayout",
  meta: null,
  isSidebarOpen: false,
  isSidebarAdminOpen: true,
  isToastMessageShow: false,
  toast: {
    message: "",
    severity: "success",
  },
  colorHeader: false
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode == "dark" ? "light" : "dark";
    },
    setLayout: (state, action) => {
      state.layout = action.payload;
    },
    setMeta: (state, action) => {
      state.meta = action.payload;
    },
    setSidebarOpen: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    setSidebarAdminOpen: (state) => {
      state.isSidebarAdminOpen = !state.isSidebarAdminOpen;
    },
    setIsToastMessageShow: (state) => {
      state.isToastMessageShow = !state.isToastMessageShow;
    },
    setMessage: (state, action) => {
      const { message, severity } = action.payload;
      state.toast.message = message;
      state.toast.severity = severity;
    },
    setColorHeader: (state, action) => {
      state.colorHeader = action.payload;
    }
  },
});

export const {
  setMode,
  setLayout,
  setSidebarOpen,
  setIsToastMessageShow,
  setMessage,
  setMeta,
  setColorHeader,
  setSidebarAdminOpen
} = globalSlice.actions;

export default globalSlice.reducer;
